import DateUtils from '@/utils/dateUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'

export class FbaWarehouseInUtil {
  /**
   * 按照国外仓库龄计算规则计算库龄
   */
  static calStorageAgeEst(detail) {
    const warehouseCode = detail.warehouse
    const weekAgeRulesRel = {
      'MON': 1,
      'TUE': 2,
      'WED': 3,
      'THU': 4,
      'FRI': 5,
      'SAT': 6,
      'SUN': 7
    }
    const warehouseInDate = DateUtils.formatStandardDate(detail.warehouseInDate)
    const warehouseOutDate = DateUtils.formatStandardDate(detail.warehouseOutDate)
    // 入库和出库时间相差天数
    const diff = DateUtils.getBetweenDays(warehouseInDate, warehouseOutDate)
    // 入库时间的周数
    const inWeek = weekAgeRulesRel[DateUtils.getDateWeek(warehouseInDate)]
    // 出库时间的周数
    const outWeek = weekAgeRulesRel[DateUtils.getDateWeek(warehouseOutDate)]
    // 库龄计算规则周数
    const overseaWarehouseAgeRules = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_OverseaWarehouse, 'warehouseCode', warehouseCode, 'warehouseAgeCalculationRules')
    // 满足跨周规则的周数，周数需要+1
    const validCrossWeeks = []
    // 国外仓库龄规则周数在入库周数前 只需找出中间周数并判断出库日期是否包含其中
    if (inWeek > overseaWarehouseAgeRules) {
      for (let i = overseaWarehouseAgeRules + 1; i <= inWeek; i++) {
        validCrossWeeks.push(i)
      }
    } else if (inWeek < overseaWarehouseAgeRules) {
      // 国外仓库龄规则周数在入库周数后 只需找出入库周数前的所有周数和库龄规则周数后的所有周数
      for (let i = 1; i <= inWeek; i++) {
        validCrossWeeks.push(i)
      }
      for (let i = overseaWarehouseAgeRules + 1; i <= 7; i++) {
        validCrossWeeks.push(i)
      }
    }
    // 计算库龄的整数周，不足一周则认为满一周
    let storageAgeWeekEst = diff === 0 ? 1 : Math.floor(diff / 7)
    // 计算库龄的小数周，有值则判断出库时间的周数是否满足跨周规则，满足则加一周
    const weekDecPart = diff % 7
    if (weekDecPart > 0) {
      storageAgeWeekEst += 1
    }
    if (diff > 0 && validCrossWeeks.indexOf(outWeek) > -1) {
      storageAgeWeekEst += 1
    }
    return {
      storageAgeDayEst: diff,
      storageAgeWeekEst: storageAgeWeekEst
    }
  }
}
